import { motion } from "framer-motion";
import { Button } from "@/components/ui/button";
import { useNavigate } from "react-router-dom";

export const HeroSection = () => {
  const navigate = useNavigate();

  return (
    <section className="relative min-h-[95vh] flex items-center justify-center overflow-hidden bg-gradient-to-br from-blue-900 via-indigo-900 to-purple-900">
      <div className="absolute inset-0 bg-grid-pattern opacity-10" />
      <motion.div 
        initial={{ opacity: 0, y: 20 }}
        animate={{ opacity: 1, y: 0 }}
        className="relative max-w-6xl mx-auto px-4 text-white text-center"
      >
        <h1 className="text-6xl md:text-8xl font-bold mb-8">
          Post-Operative Care
          <span className="block mt-4 pb-4 bg-clip-text text-transparent bg-gradient-to-r from-blue-400 to-purple-400">
            Reimagined
          </span>
        </h1>
        <p className="text-2xl md:text-3xl text-blue-100 mb-12 max-w-3xl mx-auto">
          Transforming cardiac and orthopedic recovery with AI-powered monitoring that protects both physical and cognitive health
        </p>
        <Button 
          className="text-lg px-8 py-6 bg-white text-gray-900 hover:bg-gray-100 rounded-full"
          onClick={() => navigate('/caretrack/how-it-works')}
        >
          See How It Works
        </Button>
      </motion.div>
    </section>
  );
};